import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, FakeText, Card } from '@totalsoft/rocket-ui';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { Box, TableBody, TableRow, TableCell } from '@mui/material';
import { StyledTable, StyledGrayIcon } from 'components/common/Styles';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_USER_GROUPS_WRITE } from 'constants/rightsCodes';
import UserComponent from './UserComponent';

const UsersComponent = ({ existingUsers, loading, userList, onSave, onDelete, onCancel, onAdd, inAdd, onUpdate, getUserXGroupKey }) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_USER_GROUPS_WRITE);

  return (
    <Card
      icon={GroupAddIcon}
      iconColor='primary'
      title={t('UserGroups.Users.Title')}
      actions={
        <Button startIcon={<AddIcon />} onClick={onAdd} disabled={!canWrite || inAdd} sx={{ whiteSpace: 'nowrap' }}>
          {t('Add')}
        </Button>
      }
    >
      <StyledTable>
        <TableBody>
          <TableRow>
            {loading && (
              <TableCell colSpan={2}>
                <FakeText lines={5} />
              </TableCell>
            )}
            {!loading && existingUsers.length === 0 && (
              <TableCell colSpan={4}>
                <Box display='flex' gap={1} alignItems='center' justifyContent='center'>
                  <StyledGrayIcon lsGrayIcon fontSize='small'>
                    error
                  </StyledGrayIcon>
                  <Typography color='textSecondary'>{t('UserGroups.Users.NoRecords')}</Typography>
                </Box>
              </TableCell>
            )}
          </TableRow>
          {!loading &&
            existingUsers &&
            existingUsers.map((existingUser, index) => {
              return (
                <UserComponent
                  key={getUserXGroupKey(existingUser)}
                  index={index}
                  existingUser={existingUser}
                  userList={userList}
                  onSave={onSave}
                  onDelete={onDelete}
                  onCancel={onCancel}
                  onUpdate={onUpdate}
                  canWrite={canWrite}
                />
              );
            })}
        </TableBody>
      </StyledTable>
    </Card>
  );
};

UsersComponent.propTypes = {
  existingUsers: PropTypes.array,
  loading: PropTypes.bool,
  userList: PropTypes.array,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onCancel: PropTypes.func,
  onAdd: PropTypes.func,
  inAdd: PropTypes.bool,
  onUpdate: PropTypes.func,
  getUserXGroupKey: PropTypes.func
};

export default UsersComponent;
